/*
 * Module for recent searches control
*/
rs.module("controls/universalsearch",

    /* dependencies */
    ["common/perfect-scrollbar", "ui/framework/client-templates"],

    function (perfectScrollbar, clientTemplates) {

        var scrollbars = [];
        var _resultSelectors;
        var _resultCssClasses;

        // Initialize the universal search control
        function initialize(jsSelectors, cssClasses, backendUrl, loadingTemplateKey) {

            var control = $.js(jsSelectors.universalSearch);

            var searchButton = control.js(jsSelectors.searchButton);
            var queryInput = control.js(jsSelectors.searchQuery);
            var resultsWindow = control.js(jsSelectors.resultsWindow);
            var spinner = control.js(jsSelectors.loadingSpinner);
            var searchIcon = control.js(jsSelectors.searchIcon);

            var lastQuery = "";
            var searchCounter = 0;

            searchButton.on("click", _onSearchClick);
            queryInput.keyup(_.debounce(_onQueryChange, 400));

            // initiate a search
            function _onSearchClick() {
                _initiateSearch();
            }

            function _onQueryChange() {
                _initiateSearch();
            }

            function _initiateSearch() {
                var query = queryInput.val().trim();
                if (query !== lastQuery && query.length > 0){
                    lastQuery = query;

                    searchIcon.hide();
                    // set to inline-block so the animations work  
                    spinner.css('display', 'inline-block');

                    _showResultsWindow();
                    resultsWindow.html(clientTemplates.render(loadingTemplateKey));

                    // we're going to rely on our use of good page titles here
                    var currentPageTitle = document.title;

                    // capture the search instance
                    searchCounter++;
                    var queryInstance = searchCounter;
                    $.get(backendUrl, { query: query, currentPageTitle: currentPageTitle }).done(function (results) {

                        // if these are the results for the most recent search, show them
                        if (queryInstance === searchCounter) {
                            searchIcon.show();
                            spinner.css('display', 'none');

                            resultsWindow.html(results);
                        }
                    })
                }
            }

            // display the results window
            function _showResultsWindow() {
                if (!resultsWindow.is(":visible")) {

                    resultsWindow.toggleClass(cssClasses.visible, true);

                    $(document).on("mouseup", _clickDocument);
                }
            }

            // Handler for clicking the document, outside of the visible results window
            function _clickDocument(e) {

                // clear the last query so results can be re-opened
                lastQuery = '';

                // close and detach handler
                if (!resultsWindow.is(e.target) && resultsWindow.has(e.target).length === 0) {
                    resultsWindow.toggleClass(cssClasses.visible, false);
                    $(document).off("mouseup", _clickDocument);
                }
            }
        }

        //
        // Get the search result section of the current (parent) childDiv
        // 
        function getResultSection(childDiv) {
            return $(childDiv).closestjs(_resultSelectors.scrollContent, { required: false });
        }

        //
        // Gets the search handler category (which contains title, counts, reuslts)
        // 
        function getCategory(childDiv) {
            return $(childDiv).closestjs(_resultSelectors.section, { required: false });
        }

        //
        // Deferred results are available, update the UI
        //
        function deferredResultCompleted(section, resultHtml, resultCount) {
            // Clear the searchComplete()-assigned heights, so heights are recalculated in the next searchCompleted() run
            $(section).css("height", "");
            $(section).css("max-height", "");

            // data-countjs provides the page-global selector for this section's reslut count display element
            var countSelector = $(section).data("countjs");

            // Update that count element with the provided resultCount
            if (resultCount && countSelector) {
                $.js(countSelector).html(`(${resultCount})`)
            }

            section.html(resultHtml);

            // recalculate sizes
            searchCompleted();
        }


        // search has completed, setup scrollbars
        function searchCompleted(jsSelectors, cssClasses) {

            if (jsSelectors) {
                _resultSelectors = jsSelectors;
            }

            if (cssClasses) {
                _resultCssClasses = cssClasses;
            }

            for (var scrollbar of scrollbars) {
                scrollbar.destroy();
            }
            scrollbars = [];
            
            // Needs to be in setTimeout so the perfect scrollbar will show immediately
            setTimeout(function () {

                // setup perfect scrollbars
                var scrollContents = $.js(_resultSelectors.scrollContent, { multiple: true, required: false });
                for (var scrollContent of scrollContents) {

                    var scrollContentHeight = $(scrollContent).outerHeight();
                    $(scrollContent).css("height", Math.ceil(scrollContentHeight));
                    $(scrollContent).css("max-height", Math.ceil(scrollContentHeight));

                    scrollbars.push(perfectScrollbar.createInstance(scrollContent,
                        {
                            suppressScrollX: true,
                        }));
                }

                // Expand/collapse the sub results section
                scrollContents.js(_resultSelectors.subResultsLink, { multiple: true, required: false }).click(function () {

                    // get the sub results section
                    var subResultsSection = $(this).closest(`[data-js=${_resultSelectors.searchResult}]`).js(_resultSelectors.subResultsSection);

                    var resultsExpanded = subResultsSection.is(":visible");

                    // Here we need explicit _inactive and _active classes (as opposed to just a single class we add/remove)
                    // This is becuase when results are to be expanded on load, there is a separate style that is controlling whether this should look active.
                    // In order to override that style when the results are collapsed, we need a separate class (_inactive) to do that
                    $(this).toggleClass(_resultCssClasses.active, !resultsExpanded);
                    $(this).toggleClass(_resultCssClasses.inactive, resultsExpanded);

                    subResultsSection.slideToggle(200);

                    // Since the sub results link is inside the main search result, we need to return false to stop propagation so it doesn't redirect 
                    return false;
                });

            }, 0);
        }

        var exports = {
            initialize: initialize,
            searchCompleted: searchCompleted,
            deferredResultCompleted: deferredResultCompleted,
            getResultSection : getResultSection,
            getCategory : getCategory
        }

        return exports;
    }
);